import { ExpenseEntriesTab } from "@/components/blocks/expenses/expense-entries-tab";
import { isExpenseIntegrationAvailable } from "@/lib/expense-api";

import { useProjectDetailsContext } from "../context";

export function ExpensesTab() {
  const ctx = useProjectDetailsContext();
  const {
    project,
    employees,
    numericProjectId,
    expenses,
    expensesLoading,
    dataMode,
    currentCompany,
  } = ctx;

  return (
    <>
                {expensesLoading && <span className="text-sm text-muted-foreground mb-4 block">Loading expenses...</span>}
                <ExpenseEntriesTab
                  projectId={numericProjectId}
                  projectCode={project?.code}
                  expenses={expenses}
                  employees={employees}
                  isExpenseConfigured={dataMode === 'live' ? isExpenseIntegrationAvailable(currentCompany) : undefined}
                />

    </>
  );
}
